import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const ThirdCardIcon: React.FC<UnknownObject> = () => {
  return (
    <svg viewBox="0 0 186 186" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M185.777 0H165.986H82.3608H20.0136C8.96518 0 0 8.96521 0 20.0136V84.4192V165.986V185.777C0 185.901 0.0991909 186 0.223191 186H20.0136H103.639H165.986C177.035 186 186 177.035 185.876 163.866V97.7988L186 20.0136V0.2232C186 0.0992004 185.901 0 185.777 0Z"
        fill="url(#paint0_linear_1581_8734)"
      />
      <path
        d="M156.897 168.392H28.557C21.5014 168.392 15.7974 162.676 15.7974 155.633V27.2801C15.7974 20.2245 21.5138 14.5205 28.557 14.5205H156.897C163.953 14.5205 169.657 20.2369 169.545 25.1721V153.512C169.657 162.676 163.953 168.392 156.897 168.392Z"
        fill="white"
      />
      <path
        d="M79.9926 76.8672C79.7322 76.5696 79.2859 76.3712 78.7775 76.2968C78.2691 76.2224 77.6862 76.2844 77.1654 76.4952C76.9794 76.5696 76.4586 76.9168 75.975 77.2516C75.4914 77.5864 75.045 77.9088 75.0078 77.9336C74.5986 78.2932 73.7679 78.7768 72.6147 79.2604C71.4615 79.7564 69.9983 80.2524 68.3119 80.6616C67.2455 80.9096 66.2411 81.1576 65.2987 81.2196C64.3563 81.2816 63.4759 81.1824 62.6203 80.7608C62.4219 80.6616 62.1738 80.5252 61.8266 80.3392C61.4794 80.1532 61.033 79.93 60.4378 79.6448C59.8178 79.3596 59.3963 79.062 58.7515 78.8016C58.1067 78.5412 57.2262 78.3304 55.6762 78.2188H53.6054H51.5347H49.4638H47.3931C47.2071 78.2188 46.6862 78.2312 45.9918 78.3056C45.2974 78.3676 44.4295 78.4916 43.5615 78.6776C42.6935 78.876 41.813 79.1488 40.945 79.496C40.077 79.8432 39.2338 80.2772 38.4154 80.7856C38.1922 80.922 37.9938 81.0584 37.7954 81.1824C37.6094 81.3064 37.4358 81.4428 37.2746 81.5544C37.1134 81.666 36.9771 81.7776 36.8531 81.8768C36.7291 81.976 36.6174 82.0628 36.5306 82.1372C36.1958 82.4224 35.8982 82.7076 35.6378 82.9928C35.3774 83.278 35.1294 83.5508 34.931 83.836C34.7202 84.1088 34.5466 84.3816 34.3854 84.642C34.2242 84.9024 34.0878 85.1504 33.9762 85.3984C33.8398 85.696 33.691 86.0308 33.5546 86.4028C33.4182 86.7748 33.2818 87.1468 33.1578 87.5188C33.0338 87.8908 32.9222 88.2504 32.8354 88.5728C32.7486 88.8952 32.6866 89.168 32.6494 89.3664C32.6246 89.4284 32.5875 89.6888 32.5503 90.0484C32.5131 90.408 32.4759 90.8544 32.4387 91.3132C32.4015 91.772 32.3642 92.2184 32.3394 92.578C32.3146 92.9376 32.2898 93.198 32.2898 93.2724L32.1287 96.4716L31.9674 99.6708L31.8062 102.87L31.645 106.069C31.6202 106.454 31.6822 106.826 31.8062 107.16C31.9302 107.495 32.1163 107.818 32.3643 108.078C32.5999 108.338 32.8974 108.562 33.2198 108.723C33.5422 108.884 33.9143 108.971 34.2987 108.996C34.6831 109.02 35.055 108.958 35.3898 108.834C35.7246 108.71 36.047 108.524 36.3075 108.276C36.5679 108.041 36.791 107.743 36.9522 107.421C37.1134 107.098 37.2002 106.726 37.225 106.342L37.3987 102.92L37.5722 99.4972L37.7459 96.0748L37.9194 92.6524C37.9318 92.4416 37.9567 92.1564 37.9815 91.8464C38.0063 91.5364 38.0434 91.2016 38.0806 90.8916C38.1178 90.5816 38.155 90.2964 38.1798 90.0856C38.2046 89.8748 38.2294 89.7384 38.2418 89.7136C38.2914 89.5896 38.341 89.354 38.4526 89.0564C38.5642 88.7588 38.7255 88.3868 38.9859 87.9776C39.1595 87.7048 39.3826 87.4072 39.6678 87.1096C39.953 86.812 40.2878 86.4896 40.697 86.1796C41.007 85.944 41.379 85.944 41.6766 86.0928C41.9742 86.2416 42.1975 86.5516 42.1975 86.936V89.9244V92.9128V96.7568V100.601V101.407V102.213V103.019V103.825V110.124V116.423V122.722V129.022C42.1975 129.518 42.2966 129.976 42.4826 130.41C42.6686 130.832 42.9291 131.216 43.2515 131.539C43.5739 131.861 43.9582 132.122 44.3798 132.308C44.8014 132.494 45.2727 132.593 45.7687 132.593C46.2647 132.593 46.7235 132.494 47.1575 132.308C47.5791 132.122 47.9635 131.861 48.2859 131.539C48.6083 131.216 48.8687 130.832 49.0547 130.41C49.2407 129.989 49.3398 129.518 49.3398 129.022V124.012V119.015V114.476V109.938C49.3398 109.678 49.4514 109.442 49.6126 109.268C49.7862 109.095 50.0218 108.996 50.2822 108.996H50.9147H51.547H52.1794H52.8118C53.0723 108.996 53.3079 109.107 53.4815 109.268C53.6551 109.442 53.7543 109.678 53.7543 109.938V114.638V119.337V123.987V128.637C53.7543 129.133 53.8534 129.592 54.0394 130.026C54.2254 130.448 54.4858 130.832 54.8082 131.154C55.1306 131.477 55.515 131.737 55.9366 131.923C56.3582 132.109 56.8294 132.208 57.3254 132.208C57.8214 132.208 58.2803 132.109 58.7143 131.923C59.1359 131.737 59.5202 131.477 59.8426 131.154C60.165 130.832 60.4255 130.448 60.6115 130.026C60.7975 129.604 60.8966 129.133 60.8966 128.637V122.685V116.733V110.273V103.812V102.634V101.456V100.278V99.1004V95.182V91.2636V89.4408C60.8718 88.8704 61.095 88.362 61.095 88.362C61.8762 87.0724 62.9054 87.1592 64.1206 87.2336C65.3358 87.308 66.5386 87.246 67.2578 86.998C67.7414 86.8368 70.209 86.0556 72.8254 85.014C75.4542 83.96 78.2566 82.6456 79.4222 81.418C80.4638 80.3268 80.7615 79.372 80.7243 78.5908C80.6747 77.8096 80.3026 77.2144 79.9926 76.8672Z"
        fill="white"
        stroke="#0C0E75"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M49.7738 75.032C53.0267 75.032 55.6638 72.3949 55.6638 69.142C55.6638 65.889 53.0267 63.252 49.7738 63.252C46.5208 63.252 43.8838 65.889 43.8838 69.142C43.8838 72.3949 46.5208 75.032 49.7738 75.032Z"
        fill="white"
        stroke="#0C0E75"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M102.064 84.8164C102.325 84.5188 102.771 84.3204 103.28 84.246C103.788 84.1716 104.371 84.2336 104.892 84.4444C105.078 84.5188 105.598 84.866 106.082 85.2008C106.566 85.5356 107.012 85.858 107.049 85.8828C107.458 86.2424 108.289 86.726 109.442 87.2096C110.596 87.7056 112.059 88.2016 113.745 88.6108C114.812 88.8588 115.816 89.1068 116.758 89.1688C117.701 89.2308 118.581 89.1316 119.437 88.71C119.635 88.6108 119.883 88.4744 120.23 88.2884C120.578 88.1024 121.024 87.8792 121.619 87.594C122.239 87.3088 122.661 87.0112 123.306 86.7508C123.95 86.4904 124.831 86.2796 126.381 86.168H128.452H130.522H132.593H134.664C134.85 86.168 135.371 86.1804 136.065 86.2548C136.76 86.3168 137.628 86.4408 138.496 86.6268C139.364 86.8128 140.244 87.098 141.112 87.4452C141.98 87.7924 142.823 88.2264 143.642 88.7348C143.865 88.8712 144.063 89.0076 144.262 89.1316C144.448 89.2556 144.621 89.392 144.782 89.5036C144.944 89.6152 145.08 89.7268 145.204 89.826C145.328 89.9252 145.44 90.012 145.526 90.0864C145.861 90.3716 146.159 90.6568 146.419 90.942C146.692 91.2272 146.928 91.5 147.126 91.7852C147.337 92.058 147.51 92.3308 147.672 92.5912C147.833 92.8516 147.957 93.0996 148.081 93.3476C148.217 93.6452 148.366 93.98 148.502 94.352C148.639 94.724 148.775 95.096 148.899 95.468C149.023 95.84 149.135 96.1996 149.222 96.522C149.308 96.8444 149.37 97.1172 149.408 97.3156C149.432 97.3776 149.47 97.638 149.507 97.9976C149.544 98.3572 149.581 98.8036 149.618 99.2624C149.656 99.7212 149.693 100.168 149.718 100.527C149.742 100.887 149.767 101.147 149.767 101.222L149.928 104.421L150.09 107.62L150.251 110.819L150.288 111.898C150.313 112.282 150.251 112.654 150.127 112.989C150.003 113.324 149.817 113.646 149.569 113.907C149.321 114.167 149.036 114.39 148.713 114.552C148.391 114.713 148.019 114.8 147.634 114.824C147.25 114.849 146.878 114.787 146.531 114.663C146.196 114.539 145.874 114.353 145.613 114.105C145.353 113.87 145.13 113.572 144.968 113.25C144.807 112.927 144.72 112.555 144.696 112.171L144.646 110.869L144.472 107.446L144.299 104.024L144.125 100.602C144.113 100.391 144.088 100.106 144.063 99.7956C144.038 99.4856 144.001 99.1508 143.964 98.8408C143.927 98.5308 143.89 98.2456 143.865 98.0348C143.84 97.824 143.815 97.6876 143.803 97.6628C143.753 97.5388 143.704 97.3032 143.592 97.0056C143.48 96.708 143.319 96.336 143.059 95.9268C142.885 95.654 142.662 95.3564 142.377 95.0588C142.092 94.7612 141.757 94.4388 141.348 94.1288C141.038 93.8932 140.666 93.8932 140.368 94.042C140.07 94.1908 139.847 94.5008 139.847 94.8852V97.8736V100.862V104.706V108.55V109.356V110.162V110.968V111.774V118.073V124.372V130.672V136.971C139.847 137.467 139.748 137.926 139.562 138.36C139.376 138.781 139.116 139.166 138.793 139.488C138.471 139.81 138.086 140.071 137.665 140.257C137.243 140.443 136.772 140.542 136.276 140.542C135.78 140.542 135.321 140.443 134.887 140.257C134.466 140.071 134.081 139.81 133.759 139.488C133.436 139.166 133.176 138.781 132.99 138.36C132.804 137.938 132.705 137.467 132.705 136.971V131.961V126.952V122.413V117.875C132.705 117.614 132.593 117.379 132.432 117.205C132.258 117.032 132.023 116.932 131.762 116.932H131.13H130.498H129.865H129.233C128.972 116.932 128.737 117.044 128.563 117.205C128.39 117.379 128.29 117.614 128.29 117.875V122.574V127.274V131.924V136.574C128.29 137.07 128.191 137.529 128.005 137.963C127.819 138.384 127.559 138.769 127.236 139.091C126.914 139.414 126.53 139.674 126.108 139.86C125.686 140.046 125.215 140.145 124.719 140.145C124.223 140.145 123.764 140.046 123.33 139.86C122.909 139.674 122.524 139.414 122.202 139.091C121.88 138.769 121.619 138.384 121.433 137.963C121.247 137.541 121.148 137.07 121.148 136.574V130.622V124.67V118.21V111.749V110.571V109.393V108.215V107.037V103.119V99.2004V97.3776C121.173 96.8072 120.95 96.2988 120.95 96.2988C120.168 95.0092 119.139 95.096 117.924 95.1704C116.709 95.2448 115.506 95.1828 114.787 94.9348C114.303 94.7736 111.836 93.9924 109.219 92.9508C106.59 91.8968 103.788 90.5824 102.622 89.3548C101.581 88.2636 101.283 87.3088 101.32 86.5276C101.37 85.7588 101.742 85.176 102.064 84.8164Z"
        fill="white"
        stroke="#0C0E75"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M129.803 82.9812C133.056 82.9812 135.693 80.3441 135.693 77.0912C135.693 73.8382 133.056 71.2012 129.803 71.2012C126.55 71.2012 123.913 73.8382 123.913 77.0912C123.913 80.3441 126.55 82.9812 129.803 82.9812Z"
        fill="white"
        stroke="#0C0E75"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M94.2276 84.2951C99.3434 84.2951 103.49 80.148 103.49 75.0323C103.49 69.9166 99.3434 65.7695 94.2276 65.7695C89.1119 65.7695 84.9648 69.9166 84.9648 75.0323C84.9648 80.148 89.1119 84.2951 94.2276 84.2951Z"
        fill="white"
        stroke="#373AF5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M79.4965 59.4085C79.4965 60.9957 78.5293 62.3721 77.1529 62.9549C76.6941 63.1533 76.1857 63.2649 75.6401 63.2649C73.5197 63.2649 71.7837 61.5413 71.7837 59.4085C71.7837 57.2757 73.5073 55.5645 75.6401 55.5645C77.7729 55.5645 79.4965 57.2757 79.4965 59.4085Z"
        fill="white"
        stroke="#373AF5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M116.882 39.8783C118.362 39.8783 119.561 38.6791 119.561 37.1999C119.561 35.7206 118.362 34.5215 116.882 34.5215C115.403 34.5215 114.204 35.7206 114.204 37.1999C114.204 38.6791 115.403 39.8783 116.882 39.8783Z"
        fill="white"
        stroke="#373AF5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M77.1526 116.882C79.8646 116.882 82.063 114.684 82.063 111.972C82.063 109.26 79.8646 107.062 77.1526 107.062C74.4407 107.062 72.2422 109.26 72.2422 111.972C72.2422 114.684 74.4407 116.882 77.1526 116.882Z"
        fill="white"
        stroke="#373AF5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M101.147 130.051C102.441 130.051 103.49 129.002 103.49 127.708C103.49 126.414 102.441 125.364 101.147 125.364C99.8525 125.364 98.8032 126.414 98.8032 127.708C98.8032 129.002 99.8525 130.051 101.147 130.051Z"
        fill="white"
        stroke="#373AF5"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M97.1291 106.64C98.0536 106.64 98.8031 105.891 98.8031 104.966C98.8031 104.041 98.0536 103.292 97.1291 103.292C96.2046 103.292 95.4551 104.041 95.4551 104.966C95.4551 105.891 96.2046 106.64 97.1291 106.64Z"
        fill="#373AF5"
        stroke="#373AF5"
        strokeMiterlimit="10"
      />
      <path
        d="M86.6389 138.086C87.5634 138.086 88.3129 137.337 88.3129 136.412C88.3129 135.488 87.5634 134.738 86.6389 134.738C85.7143 134.738 84.9648 135.488 84.9648 136.412C84.9648 137.337 85.7143 138.086 86.6389 138.086Z"
        fill="#373AF5"
        stroke="#373AF5"
        strokeMiterlimit="10"
      />
      <path
        d="M86.4776 69.9485L78.0952 62.3721"
        stroke="#373AF5"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M79.1616 57.8457L114.551 38.4893"
        stroke="#373AF5"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M116.882 39.8779L100.093 67.8523"
        stroke="#373AF5"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M78.269 107.061L89.491 82.9805"
        stroke="#373AF5"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M94.2275 84.2949L97.1291 104.966"
        stroke="#373AF5"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M80.7241 115.345L98.8033 126.703"
        stroke="#373AF5"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M86.6387 136.413L99.1751 128.973"
        stroke="#373AF5"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M118.557 43.3379H131.949"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M118.557 46.5742H128.563"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M118.557 50.0342H125.811"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M101.792 103.714H115.183"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M101.792 106.95H111.786"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M101.792 110.41H109.046"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M58.8506 50.2939H75.6402"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M58.8506 53.5303H71.1266"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M58.8506 56.9902H68.1506"
        stroke="#1B1B1B"
        strokeMiterlimit="10"
      />
      <path
        d="M58.8506 60.7852H64.9886"
        stroke="#252D62"
        strokeMiterlimit="10"
      />
      <path
        d="M101.792 113.608H106.789"
        stroke="#252D62"
        strokeMiterlimit="10"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1581_8734"
          x1="4.84375"
          y1="42.2329"
          x2="201.033"
          y2="84.5094"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F5F8FF" />
          <stop offset="1" stopColor="#E1E3F9" />
        </linearGradient>
      </defs>
    </svg>
  )
}
